module.exports = __webpack_public_path__ + "img/disk_alert.c74a173b.png";